<template>
  <ClientOnly>
    <div>
      <BreadcrumbWrapper class="margin-bottom-xs" current-page="GiftCardBalance" />
      <h1>Gift Cards</h1>
      <Tabs id="gift-card-tabs" class="cell large-margin-top-xl margin-top-m" :tabs="tabIds">
        <template v-for="tab in tabs" :key="'head-' + tab.id" #[`v-tab-head-${tab.id}`]>
          <div :id="tab.id" class="padding-left-s padding-right-xs">
            {{ tab.label }}
          </div>
        </template>
        <template v-for="tab in tabs" :key="'panel-' + tab.id" #[`v-tab-panel-${tab.id}`]>
          <div class="cls-tab-panel-container">
            <component :is="tab.component" />
          </div>
        </template>
      </Tabs>
    </div>
    <template #fallback>
      <div class="cls-gift-card-skeleton">
        <AtomicUiSkeleton :style="{ height: 'clamp(340px, 45vw, 510px)' }" />
      </div>
    </template>
  </ClientOnly>
</template>

<script setup>
import { onMounted } from 'vue';
import Tabs from '@atomic-ui/tabs/Tabs';
import { fireTag } from '@vue-util/tagManager';
import { brand, brandName } from 'config';
import BalanceLookupForm from './balance-lookup-form';
import TermsAndConditions from './terms-and-conditions';
import BreadcrumbWrapper from '@/components/common/BreadcrumbWrapper.vue';
import AtomicUiSkeleton from '@atomic-ui/skeleton/Skeleton';

useHead({
  title: `Gift Card Balance - My Account - ${brandName}`,
});

const tabs = [
  {
    id: 'gift-card-balance-lookup',
    label: brand === 'bcom' ? 'Gift Card balance' : 'Gift Card Balance',
    component: BalanceLookupForm,
  },
  {
    id: 'terms-and-conditions',
    label: brand === 'bcom' ? 'Terms & conditions' : 'Terms & Conditions',
    component: TermsAndConditions,
  },
];

const tabIds = tabs.map((tab) => tab.id);

onMounted(() => {
  fireTag('view', {
    page_name: 'gift card balance lookup page',
    page_type: 'my account',
    adobe_page_name: 'gift card balance lookup page',
  });
});
</script>
<style lang="scss">
#gift-card-tabs {
  section.tab-panel {
    padding-top: rem-calc(32);
  }
}
</style>

<style lang="scss" scoped>
.cls-tab-panel-container {
  min-height: rem-calc(420);
  contain: layout style;
  content-visibility: auto;
  contain-intrinsic-size: auto 420px;
}

.cls-gift-card-skeleton {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}
</style>
